import { Decimal } from 'decimal.js';
import { sharesAfterFee, SPORTS_FEE_RATE } from './calc';

export type PayoutModel =
  | { kind: 'shares'; rate: string; exponent: number; disabled?: boolean; assumed?: boolean; feeModel?: 'min' }
  | { kind: 'profit'; rate: string }
  | { kind: 'freebet'; rate: string };
export const defaultPolyFee = (): PayoutModel => ({ kind: 'shares', rate: SPORTS_FEE_RATE, exponent: 1, assumed: true });
export const isPolySource = (source: string): boolean => /^(poly|polymarket)(?:$|[-_:])/i.test(source.trim());

/** Stake is total cash spent. A buy fee reduces received shares, never adds a second cash debit. */
export function cashPayout(stake: Decimal.Value, odds: Decimal.Value, model?: PayoutModel, price?: Decimal.Value): Decimal {
  const cash = new Decimal(stake), k = new Decimal(odds);
  if (model?.kind === 'shares') {
    const p = price === undefined ? new Decimal(1).div(k) : new Decimal(price);
    if (!p.gt(0) || !p.lt(1)) throw new Error('Цена шера должна быть от 0 до 100 центов');
    return sharesAfterFee(cash.div(p), p, model.disabled ? '0' : model.rate, model.exponent, model.feeModel);
  }
  const win = cash.times(k.minus(1)).times(new Decimal(1).minus(model?.rate ?? '0'));
  return model?.kind === 'freebet' ? win : cash.plus(win);
}
